<template>
  <div>
    <BaseModal
      :config="InfoTrackerModalLabel"
      @ResetFields="resetFields"
      @SaveChanges="saveChanges();"
    >
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
        <form ref="refInfoTrackerForm">
          <div id="pageErrors" class="alert alert-danger" v-if="pageErrors.length>0">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <!-- Custom Error Handler -->
          <div id="Customerror" class="alert alert-danger" v-show="customerrors.length>0">
            <span v-show="customerrors.length" class="alert-danger">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="error in customerrors" :key="error">{{ error }}</li>
              </ul>
            </span>
          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label class="section-title">Information Tracker Details</label>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Partner</label>
              <!-- <input
                type="text"
                readonly="true"
                v-model="InfoTrackerFormConfig.PartnerTitle"
                class="form-control"
              >-->
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchPartner"
                  name="Partner"
                  class="form-control"
                  v-model="partnerAutoCompleteDisplayedValue.displayedValue"
                  :data-source="partnerAutoCompleteSource"
                  :data-text-field="'FullName'"
                  :filter="'contains'"
                  :placeholder="'Search for Partner'"
                  @select="onPartnerAutoCompleteSelect"
                  @open="onPartnerOpen"
                  @close="onPartnerClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Program</label>
              <!-- <input
                type="text"
                v-model="InfoTrackerFormConfig.ProgramTitle"
                readonly="true"
                class="form-control"
              >-->
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchProgram"
                  class="form-control"
                  name="Program"
                  v-model="programAutoCompleteDisplayedValue.displayedValue"
                  :data-source="programAutoCompleteSource"
                  :data-text-field="'Title'"
                  :filter="'contains'"
                  :placeholder="'Search for Program'"
                  @select="onProgramAutoCompleteSelect"
                  @open="onProgramOpen"
                  @close="onProgramClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <input
                class="k-checkbox form-control"
                type="checkbox"
                v-model="InfoTrackerFormConfig.SignaturePage"
                id="chkSignature"
              />
              <label class="k-checkbox-label" for="chkSignature">Receive Signature Page?</label>
            </div>
            <div class="form-group col-md-6">
              <input
                class="k-checkbox form-control"
                type="checkbox"
                v-model="InfoTrackerFormConfig.Receive83b"
                id="chk83b"
              />
              <label class="k-checkbox-label" for="chk83b">Receive 83(b)?</label>
            </div>
          </div>

          <!-- <div class="form-row">
            <div class="form-group col-md-6">
              <label>Last Completed</label>
              <div class="input-group">
                <kendo-datepicker
                  placeholder="Select Date"
                  :value="InfoTrackerFormConfig.LastCompleted"
                  v-model="InfoTrackerFormConfig.LastCompleted"
                  :format="'MM/dd/yyyy'"
                  id="dtlastCompleted"
                  width="100%"
                  @open="_setCurrentDateifNull"
                ></kendo-datepicker>
              </div>
            </div>
          </div>-->

          <div class="form-row">
            <!-- <div class="form-group col-md-6">
              <label class="required-label">Amount Owed</label>
              <input
                type="text"
                v-model="InfoTrackerFormConfig.AmountOwed"
                class="form-control"
                placeholder="Amount Owed"
                name="Amount Owed"
              />
            </div>-->
            <div class="form-group col-md-6">
              <label>Payment</label>
              <input
                type="text"
                v-model="InfoTrackerFormConfig.Payment"
                class="form-control"
                placeholder="Payment"
                v-validate="'numeric'"
                name="Payment"
              />
            </div>
            <div class="form-group col-md-6" style="margin: 30px 0px">
              <input
                class="k-checkbox form-control"
                type="checkbox"
                v-model="InfoTrackerFormConfig.Receive83bFiledWithIRS"
                id="chk83bIRS"
              />
              <label class="k-checkbox-label" for="chk83bIRS">Receive 83(b) Filed with IRS?</label>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Method of Payment</label>
              <div id="kendo-select">
                <kendo-dropdownlist
                  v-model="InfoTrackerFormConfig.MethodofPayment"
                  :data-source="dropdownOptions.PaymentMethod"
                  :data-text-field="'Option'"
                  :option-label="'Select Method of Payment'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>
              </div>

              <!-- <select v-model="InfoTrackerFormConfig.MethodofPayment" class="form-control">
                <option
                  v-for="option in dropdownOptions.PaymentMethod"
                  :key="option.Id"
                  :value="option.Option"
                >{{option.Option}}</option>
              </select>-->
            </div>
            <div class="form-group col-md-6">
              <label>Check Number</label>
              <input
                type="text"
                v-model="InfoTrackerFormConfig.CheckNumber"
                class="form-control"
                placeholder="Check Number"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Date Deposited</label>
              <div class="input-group">
                <kendo-datepicker
                  placeholder="Select Date"
                  :value="InfoTrackerFormConfig.DateDeposited"
                  v-model="InfoTrackerFormConfig.DateDeposited"
                  :format="'MM/dd/yyyy'"
                  id="dtdeposited"
                  width="100%"
                  @open="_setCurrentDateifNull"
                ></kendo-datepicker>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Date Wired</label>
              <div class="input-group">
                <kendo-datepicker
                  placeholder="Select Date"
                  :value="InfoTrackerFormConfig.DateWired"
                  v-model="InfoTrackerFormConfig.DateWired"
                  :format="'MM/dd/yyyy'"
                  id="dtWired"
                  width="100%"
                  @open="_setCurrentDateifNull"
                ></kendo-datepicker>
              </div>
            </div>
          </div>
        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from "@/components/base/BaseModal.vue";
import $ from "jquery";
import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import { mapActions, mapGetters, mapState } from "vuex";
import { isNullOrUndefined } from "util";

export default {
  name: "InfoTrackerForm",
  props: [
    "InfoTrackerFormConfig",
    "InfoTrackerModalLabel",
    "partnerAutoCompleteDisplayedValue",
    "programAutoCompleteDisplayedValue"
  ],

  mixins: [apiUtil, funcUtil],

  data: function() {
    return {
      BaseModelInformationTracking: BaseModelInformationTracking,
      BaseModelInputControl: BaseModelInputControl,
      dropdownOptions: {
        PaymentMethod: { model: "", dataSource: [] }
      },
      programAutoCompleteSource: [],
      partnerAutoCompleteSource: [],
      bPartnerValid: true,
      bProgramValid: true,

      customerrors: [],
      pageErrors: []
    };
  },

  components: {
    BaseModal
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"]),
    ...mapState("postModule", ["response"])
  },

  mounted() {
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    this.getProgramAutoCompleteData();
    this.getPartnerAutoCompleteData();
    this.ShowAutoCompleteListOnFocus("SearchPartner");
    this.ShowAutoCompleteListOnFocus("SearchProgram");
    this.getInputControls();
  },

  methods: {
    ...mapActions("postModule", ["CreateItems", "UpdateItems"]),

    Validate() {
      const self = this;
      self.pageErrors = [];
      let form = self.InfoTrackerFormConfig;

      //Partner
      if (!(form.PartnerTitle && form.PartnerId)) {
        self.pageErrors.push("Partner is required");
      }
      //Program
      if (!(form.ProgramTitle && form.ProgramId)) {
        self.pageErrors.push("Program is required");
      }

      // Payment
      // if (!form.Payment && form.Payment <= 0) {
      //   self.pageErrors.push(
      //     "Payment should be greater than or equal to Zero."
      //   );
      // }

      return self.pageErrors.length > 0 ? false : true;
    },

    getProgramAutoCompleteData() {
      this.programAutoCompleteSource = this.withFilter(BaseModelProgram.list);
    },

    getPartnerAutoCompleteData() {
      let partnerFilterQuery = {
        batchQuery: true,
        filter: function(o) {
          return (
            o.PartnerStatus != "Retired Employee" &&
            o.PartnerStatus != "Former Employee"
          );
        },
        limit: 5000
      };
      this.partnerAutoCompleteSource = this.withFilter(
        BaseModelPartner.list,
        partnerFilterQuery
      );
    },

    onPartnerAutoCompleteSelect(e) {
      const self = this;
      self.bPartnerValid = true;

      self.InfoTrackerFormConfig.PartnerId = e.dataItem.Id;
      self.InfoTrackerFormConfig.PartnerTitle = e.dataItem.FullName;
    },
    onPartnerOpen() {
      const self = this;
      self.bPartnerValid = false;
    },
    onPartnerClose() {
      const self = this;
      if (!this.bPartnerValid) {
        self.InfoTrackerFormConfig.PartnerId = null;
        self.InfoTrackerFormConfig.PartnerTitle = null;
      }
    },

    onProgramAutoCompleteSelect(e) {
      const self = this;
      self.bProgramValid = true;

      self.InfoTrackerFormConfig.ProgramId = e.dataItem.Id;
      self.InfoTrackerFormConfig.ProgramTitle = e.dataItem.Title;
    },
    onProgramOpen() {
      const self = this;
      self.bProgramValid = false;
    },
    onProgramClose() {
      const self = this;
      if (!self.bProgramValid) {
        self.InfoTrackerFormConfig.ProgramId = null;
        self.InfoTrackerFormConfig.ProgramTitle = null;
      }
    },

    // save Partner data
    saveChanges: function() {
      const self = this;
      if (self.Validate()) {
        self.InfoTrackerFormConfig.SignaturePage = self.InfoTrackerFormConfig
          .SignaturePage
          ? "Received"
          : "Not Received";
        self.InfoTrackerFormConfig.Receive83b = self.InfoTrackerFormConfig
          .Receive83b
          ? "Received"
          : "Not Received";
        self.InfoTrackerFormConfig.Receive83bFiledWithIRS = self
          .InfoTrackerFormConfig.Receive83bFiledWithIRS
          ? "Received"
          : "Not Received";

        if (isNullOrUndefined(self.InfoTrackerFormConfig.Payment)) {
          self.InfoTrackerFormConfig.Payment = "";
        }

        if (self.InfoTrackerModalLabel.modalAddorEdit == "Add") {
          // console.log(JSON.stringify(self.InfoTrackerFormConfig));
          var addFormValues = self.InfoTrackerFormConfig;

          let createItem = {
            list: this.BaseModelInformationTracking,
            payload: addFormValues
          };

          self._APICrudPopup("APICrudpopup");
          this.CreateItems(createItem)
            .then(res => {
              self.$emit("SaveComplete");
              this._AlertPopup("Data Saved Successfully!", "success");
            })
            .catch(error => {
              this._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {});
        } else {
          // console.log(JSON.stringify(self.InfoTrackerFormConfig));
          var editForm = self.InfoTrackerFormConfig;

          let updateItem = {
            list: self.BaseModelInformationTracking,
            payload: editForm
          };

          self._APICrudPopup("APICrudpopup");
          this.UpdateItems(updateItem)
            .then(res => {
              self.$emit("SaveComplete");
              this._AlertPopup("Data Saved Successfully!", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {});
        }
        $("#BaseModal").modal("toggle");
        self.resetFields();
      }
    },

    // reset the form fields
    resetFields: function() {
      const self = this;
      self.customerrors = [];
      self.pageErrors = [];
      //self.$refs.refInfoTrackerForm.reset();
      self.errors.clear();
      //Object.assign(self.$data, self.$options.data.call(self));
    },

    getInputControls() {
      const self = this;

      let result = self.getLocalInputControls(self.BaseModelInputControl.list);
      self.dropdownOptions["PaymentMethod"] = result["PaymentMethod"];
    }
  }
};
</script>